import { useEffect, useState } from 'react';
import { DocumentHtmlDataModel } from '../../../models/document.html.data.model';
import {
  fetchDocumentUploadHTML,
  selectAllDocumentUploadHTML,
} from '../../../slices/document-upload-html/documentUploadHTMLSlice';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { NWClient } from '../../../client/NWClient';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { UseDocumentDetailsProps } from '../types';

export const useDocumentVersions = ({
  id,
  isDocumentContract,
  allowedGettingVersions,
}: UseDocumentDetailsProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const documentUploadHTMLArray = useAppSelector(selectAllDocumentUploadHTML);
  const [versionHTML, setVersionHTML] = useState<string>(null);
  const [pendingStatus, setPendingStatus] = useState<boolean>(false);
  const [versionModalOpened, setVersionModalOpened] = useState<boolean>(false);

  const versionsArray = [...documentUploadHTMLArray]
    .filter((el) => el.document_upload === id)
    .sort()
    .reverse();

  const getDocumentUploadHTML = (id: number) => {
    setPendingStatus(true);
    setVersionHTML(null);
    NWClient.get('document-upload-html-data', id)
      .then((res: DocumentHtmlDataModel) => {
        setVersionHTML(res.html);
      })
      .catch((error) => {
        toast.error(error.message || t('messages.errorOccurred'));
      })
      .finally(() => setPendingStatus(false));
  };

  useEffect(() => {
    if (id && isDocumentContract !== undefined && !isDocumentContract && allowedGettingVersions) {
      dispatch(fetchDocumentUploadHTML({ data: { document_upload: Number(id) } }));
    }
  }, [id, isDocumentContract, allowedGettingVersions, dispatch]);

  return {
    setVersionHTML,
    versionHTML,
    pendingStatus,
    getDocumentUploadHTML,
    setVersionModalOpened,
    versionModalOpened,
    versionsArray,
  };
};
